/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Link } from 'react-router-dom';

interface OutcomeProps {
  title: string;
  message?: React.ReactNode;
  link?: string;
  linkText?: string;
  reload?: boolean;
}

export const renderOutcome = ({
  title,
  message,
  link,
  linkText = '',
  reload = false,
}: OutcomeProps) => {
  return <div className='genericOnboarding row'>
    <div className='offset-3 col-6'>
      <h1>{title}</h1>
      <p>{message}</p>
      {link &&
      <Link to={link}
            onClick={(e) => {
              if (reload) {
                e.preventDefault();
                window.location.href = link
              }
            }}
            className='mt-4 btn btn-primary w-100'>
        {linkText}
      </Link>
      }
    </div>
  </div>
};
